<script>
  export default{
    name: 'dash-analise-cadastro',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="panel wrapper column-flex">
    <div class="flex-fixed">
      <label class="i-switch bg-warning pull-right">
        <input type="checkbox" class="" aria-invalid="false">
        <i></i>
      </label>
      <h4 class="font-thin m-t-none m-b text-muted">Análise de Cadastro</h4>
    </div>
    <ul class="list-group flex-fill overflow-auto alt">
      <li class="list-group-item no-padder-horizontal">
        <div class="media">
          <!--Quando tiver imagem do arrematante <span class="pull-left thumb-sm"><img src="img/a1.jpg" alt="..." class="img-circle"></span>-->
          <div class="pull-right text-warning m-t-sm">
            <i class="fa fa-circle"></i> aguardando análise
          </div>
          <div class="media-body">
            <div><a href="">João Pedro Amorim</a></div>
            <small class="text-muted">atualizado 2 minutos atrás</small>
          </div>
        </div>
      </li>

      <li v-for="i in 10" class="list-group-item no-padder-horizontal">
        <div class="media">
          <!--Quando tiver imagem do arrematante <span class="pull-left thumb-sm"><img src="img/a1.jpg" alt="..." class="img-circle"></span>-->
          <div class="pull-right text-warning m-t-sm">
            <i class="fa fa-circle"></i> aguardando análise
          </div>
          <div class="media-body">
            <div><a href="">Pedro Thiago Pereira</a></div>
            <small class="text-muted">atualizado 2 horas atrás</small>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// AnaliseCadastro.vue?6051f18a